import mutations from './mutations'
import actions from './actions'

const admin = {
    namespaced: true,
    state: {
        articles: [],
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            fromDate: null,
            toDate: null,
            shown: null,
            phone: null,
            scope: null
        }
    },
    mutations,
    actions
}

export default admin
